var map = {
	"./api.jpg": 726,
	"./applicationCS.jpg": 618,
	"./desarrolloweb.jpg": 53,
	"./galeria-1.jpg": 903,
	"./galeria-2.jpg": 920,
	"./galeria-3 copy.jpg": 790,
	"./galeria-3.jpg": 237,
	"./galeria-4.jpg": 614,
	"./galeria-5.jpg": 659,
	"./galeria-6.jpg": 623,
	"./logo_ed.png": 434,
	"./testing.jpg": 450,
	"./work_process-1024x206.png": 397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;